import { SkillCard, SkillCardLevel } from '@/components/custom/skill';
import { WidgetTitle } from '@/components/custom/widget';
import { Badge } from '@/components/ui/badge';

export function EssayConsultSkill({ competence, item }) {
  const checkScore = (score, maxScore) => {
    const oneThird = maxScore / 3;
    const twoThirds = oneThird * 2;

    if (score <= oneThird) {
      return 'danger';
    } else if (score > oneThird && score <= twoThirds) {
      return 'warning';
    } else if (score > twoThirds) {
      return 'success';
    }
  };

  return (
    <SkillCard>
      <span>{item?.name}</span>
      <WidgetTitle>{item?.description}</WidgetTitle>

      <Badge
        square
        variant={checkScore(competence?.score, competence?.['max_grade'])}
      >
        <strong>{competence?.score}</strong>/{competence?.['max_grade']} pts
      </Badge>

      <SkillCardLevel>
        {/* <span>Nível {competence?.level}</span> */}
        <p>{competence?.comment}</p>
      </SkillCardLevel>
    </SkillCard>
  );
}
